module.exports = __webpack_public_path__ + "static/media/ccos-logo-removebg-preview.2050230a.png";